import { DateTime } from "luxon";

/**
 * A time format options to specify how the datetime is printed.
 * @see https://moment.github.io/luxon/api-docs/index.html#datetimetolocalestring
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 */
export const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};
export const DATE_FORMAT_WITH_WEEKDAY: Intl.DateTimeFormatOptions = {
  ...DATE_FORMAT,
  weekday: "short",
};
export const TIME_FORMAT: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

export const DATE_AND_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  ...DATE_FORMAT,
  ...TIME_FORMAT,
};
export const DATE_AND_TIME_FORMAT_WITH_WEEKDAY: Intl.DateTimeFormatOptions = {
  ...DATE_FORMAT_WITH_WEEKDAY,
  ...TIME_FORMAT,
};

export const normalizeDateString = (value: string) => value.replace(/,\s*/g, " ").replace(/\s+/g, " ").trim();

export const formatRangeWeekdaySingle = (params: {
  fromISO: string;
  toISO: string;
  timezone: string;
  locale: string;
}) => {
  const { fromISO, toISO, timezone, locale } = params;
  const from = DateTime.fromISO(fromISO).setZone(timezone).setLocale(locale);
  const to = DateTime.fromISO(toISO).setZone(timezone).setLocale(locale);

  if (from.hasSame(to, "day")) {
    return normalizeDateString(from.toLocaleString(DATE_FORMAT_WITH_WEEKDAY));
  }

  return `${from.toLocaleString(DATE_FORMAT)}-${to.toLocaleString(DATE_FORMAT)}`;
};
